import AccountLinked from './AccountLinked';

export default AccountLinked;
